/**
 * Created by Z179603 on 6/14/2016.
 */
angular
    .module('cvsApp')
    .directive('pageLoad', ['$parse',"$http", "$rootScope", "$location","$state","RequestServiceHelper", function($parse,$http, $rootScope,$location,$state,RequestServiceHelper) { // Inject $parse
    return {
        restrict: 'A',
        link: function(scope, element, attr) {

           /**
            *  07/03/2020 Viswa - z241843
            *  US220286: Stop using WCM for reading configuration values in Specialty Payments Components for Make a Payment Page
            */
            //RequestServiceHelper.wcmService("FastToggle").then(wcmConfigSuccessResponse);
            /*$http.get('app/data/switch.json')
                .then(wcmConfigResponse);*/
            function wcmConfigSuccessResponse(success){
                if(success && success.FastToggle && success.FastToggle.header && success.FastToggle.header.responseCode && success.FastToggle.header.responseCode=="DBPL0000"){
                    loadComponentConfig(success.FastToggle.details.fast_config);
                }else{
                    loadComponentConfig(wcmContent.fast_config);
                }
            };

            function loadComponentConfig(response) {
                var configValues=response.component_config.config;
                var componentName=attr["pageLoad"];
                var deviceType="desktop";
                if( isMobile.any()) {
                    deviceType="mobile";
                }else if(cvsUtility.queryMap.mobileAppStyle!=undefined && (cvsUtility.queryMap.mobileAppStyle==true || cvsUtility.queryMap.mobileAppStyle=="true")){
                    deviceType="mobileApp";
                }

                angular.forEach(configValues,function(eachList){
                    if(eachList.componentname===componentName){
                        var logstoBeEnabled=eachList.loglevel;
                        if(logstoBeEnabled){
                            CVS.Config.loglevel.info=logstoBeEnabled.info && logstoBeEnabled.info=="true"? true:false;
                            CVS.Config.loglevel.error=logstoBeEnabled.error && logstoBeEnabled.error=="true"? true:false;
                            CVS.Config.loglevel.warn=logstoBeEnabled.trace && logstoBeEnabled.trace=="true"? true:false;
                            CVS.Config.loglevel.debug=logstoBeEnabled.debug && logstoBeEnabled.debug=="true"? true:false;
                        }
                        switch(deviceType) {
                            case "mobile":
                                if(eachList.channelswitches.mobileweb==="N"){
                                    $state.go("error");
                                }
                                break;
                            case "mobileApp":
                                if(eachList.channelswitches.mobileapp==="N"){
                                    $state.go("error");
                                }
                                break;
                            default:
                                if(eachList.channelswitches.desktop==="N"){
                                    $state.go("error");
                                }
                                break;
                        }
                    }
                });

            };

            var isMobile = {
                Android: function() {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function() {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function() {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function() {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function() {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: function() {
                    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                }
            };
           /* var loadHandler = function(){
                $parse(attr.imgLoad);
            };
                 /!* Parse value of
             'imgLoad' attribute *!/
            element.on('load', function() {
                loadHandler(scope); /!* Run the function returned by $parse.
                 It needs the scope object
                 to operate properly. *!/
            });*/
        }
    };
}]);
